import * as React from "react";
import './Intro.css';
import './Pick.css';
import '../../components/Typograph.css';
import PropTypes from "prop-types";
import PhoneAppHeader from "../../components/PhoneAppHeader";
import PhoneAppFooter from "../../components/PhoneAppFooter";

Intro.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    disablePhoneMode: PropTypes.func.isRequired,
}

export default function Intro(props) {
    return (
        <div className="page">
            <PhoneAppHeader title="Introductie scherm" quitPhoneApp={props.disablePhoneMode}/>

            <div className="phone-page-middle">
                <h1 className="phone-welcome-title">Een vrijblijvende offerte op uw situatie afgesteld.</h1>
                <p className="phone-welcome-text">
                    Hier kunt u uw situatie achterlaten.<br/>
                    Een specialist stelt de benodigde producten voor u samen.<br/>
                    Vervolgens krijgt u een vrijblijvend voorstel in uw email.<br/>
                </p>
            </div>

            <PhoneAppFooter onNext={props.handleNextPage} enableNext/>
        </div>
    );
}